function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgWarning = function SvgWarning(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Warning' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("g", {
    transform: "translate(0.000000, 3.000000)"
  }, React.createElement("path", {
    d: "M24.0000923,0 L9.23076923e-05,42 L48.0000923,42 L24.0000923,0 Z M24.0000923,3.76226667 L44.8191692,40.1333333 L3.18101538,40.1333333 L24.0000923,3.76226667 Z"
  }), React.createElement("polygon", {
    points: "25.3846154 15.8666667 22.6153846 15.8666667 23.0769231 28.9333333 24.9230769 28.9333333"
  }), React.createElement("path", {
    d: "M24,31.7246533 C22.98,31.7246533 22.1538462,32.56092 22.1538462,33.59132 C22.1538462,34.62172 22.98,35.4579867 24,35.4579867 C25.02,35.4579867 25.8461538,34.62172 25.8461538,33.59132 C25.8461538,32.56092 25.02,31.7246533 24,31.7246533"
  })));
};

SvgWarning = pure(SvgWarning);
SvgWarning.displayName = 'SvgWarning';
export default SvgWarning;